import { ComumService } from './../../comum/comum.service';
import { Evento } from './../../comum/eventos/evento';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Dashboard } from '../../comum/modelos/dashboard';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IndicadorService } from '../../indicador/indicador.service';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { RegiaoService } from '../../regiao/regiao.service';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { Indicador } from '../../comum/modelos/indicador';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { RegiaoCliente } from '../../comum/modelos/regiao-cliente';
import { TipoPontoFisico } from '../../comum/modelos/tipo-ponto-fisico';
import { ParametroGrafico } from '../../comum/modelos/parametro-grafico';
import { SelectItem } from 'primeng/primeng';
import { PeriodicidadeDados } from '../../comum/modelos/periodicidade-dados';
import { DashboardsService } from '../dashboards.service';
import { PontoFisicoParametroGrafico } from '../../comum/modelos/ponto-fisico-parametro-grafico';
import { TipoPontoFisicoParametroGrafico } from '../../comum/modelos/tipo-ponto-fisico-parametro-grafico';
import { RegiaoParametroGrafico } from '../../comum/modelos/regiao-parametro-grafico';
import { CookieService } from 'angular2-cookie/core';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioService } from '../../usuario/usuario.service';
import { PermissoesAcessoService } from '../../permissoes-acesso/permissoes-acesso.service';
import { AuthService } from '../../auth/auth.service';
import { UsuarioParametroGrafico } from '../../comum/modelos/usuario-parametro-grafico';
import { AreaCliente } from '../../comum/modelos/area-cliente';
import { AreaParametroGrafico } from '../../comum/modelos/area-parametro-grafico';
import { ClienteService } from '../../cliente/cliente.service';

@Component({
    // tslint:disable: indent
    selector: 'app-parametros-grafico',
    templateUrl: './parametros-grafico.component.html',
    styleUrls: ['./parametros-grafico.component.css']
})
export class ParametrosGraficoComponent implements OnInit {
    @Output() parametrosGraficoEvent: EventEmitter<ParametroGrafico>;
    @Input() origem: string;
    @Input() parametroGraficoInput: ParametroGrafico;

    dashboards: Dashboard[];

    paginacao: Paginacao;

    evento: Evento;

    checked: boolean;

    dataInicioReferencia: Date;
    dataFimReferencia: Date;
    pontosFisicos: PontoFisico[];
    indicadores: Indicador[];
    regioes: RegiaoCliente[];
    areas: AreaCliente[];
    tiposPontoFisico: TipoPontoFisico[];
    periodicidades: PeriodicidadeDados[];
    parametroGrafico: ParametroGrafico;
    pontosFisicosParametroGrafico: PontoFisicoParametroGrafico[];
    tiposPontoFisicoParametroGrafico: TipoPontoFisicoParametroGrafico[];
    areasParametroGrafico: AreaParametroGrafico[];
    regioesParametroGrafico: RegiaoParametroGrafico[];
    usuariosParametroGrafico: UsuarioParametroGrafico[];
    usuarios: Usuario[];
    pontosFisicosSelectItem: SelectItem[] = [];
    pontosFisicosSelecionados: number[] = [];
    tipoPontoFisicoSelectItem: SelectItem[] = [];
    tiposPontoFisicoSelecionados: number[] = [];
    regioesSelectItem: SelectItem[] = [];
    areasSelectItem: SelectItem[] = [];
    regioesSelecionadas: number[] = [];
    areasSelecionadas: number[] = [];
    usuariosSelectItem: SelectItem[];
    usuariosSelecionados: number[] = [];
    selecione = 'Selecione';
    ultimosDias: boolean;
    ultimasSemanas: boolean;
    ultimosMeses: boolean;
    ultimosAnos: boolean;
    rangeDatas: boolean;
    tipoIndicador: number;

    dateFormat = 'dd/mm/yy';
    pt: any;

    public loading = false;
    public statusCode: number;

    constructor (private _indicadorService: IndicadorService,
        private _pontoFisicoService: PontoFisicoService,
        private _regiaoService: RegiaoService,
        private _dashboardService: DashboardsService,
        private _permissaoService: PermissoesAcessoService,
        private _usuarioService: UsuarioService,
        private _clienteService: ClienteService,
        private authService: AuthService,
        private _comumService: ComumService,
        private _cookieService: CookieService) {
        this.paginacao = new Paginacao();
        this.parametrosGraficoEvent = new EventEmitter<ParametroGrafico>();
        this.evento = this._comumService.evento;
        this.pontosFisicos = new Array<PontoFisico>();
        this.indicadores = new Array<Indicador>();
        this.regioes = new Array<RegiaoCliente>();
        this.areas = new Array<AreaCliente>();
        this.tiposPontoFisico = new Array<TipoPontoFisico>();
        this.parametroGrafico = new ParametroGrafico();
        this.pontosFisicosParametroGrafico = new Array<PontoFisicoParametroGrafico>();
        this.tiposPontoFisicoParametroGrafico = new Array<TipoPontoFisicoParametroGrafico>();
        this.regioesParametroGrafico = new Array<RegiaoParametroGrafico>();
        this.areasParametroGrafico = new Array<AreaParametroGrafico>();
        this.pontosFisicosSelectItem = new Array<SelectItem>();
        this.tipoPontoFisicoSelectItem = new Array<SelectItem>();
        this.regioesSelectItem = new Array<SelectItem>();
        this.areasSelectItem = new Array<SelectItem>();
        this.periodicidades = new Array<PeriodicidadeDados>();
        this.usuariosSelectItem = new Array<SelectItem>();
        this.usuarios = new Array<Usuario>();
        this.usuariosParametroGrafico = new Array<UsuarioParametroGrafico>();
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.ultimosAnos = false;
        this.rangeDatas = false;

        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 3000);
        }

    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.pt = {
            firstDayOfWeek: 1,
            dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
            dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
                'outubro', 'novembro', 'dezembro'],
            monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
            today: 'Hoje',
            clear: 'Apagar'
        };
        this.loading = true;
        this.tipoIndicador = 2;
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
        const usuario = JSON.parse(this._cookieService.get('usuario'));

        if (this.authService.isAdmin) {
            this._usuarioService.obterUsuariosHttp(idCliente).subscribe(usuarios => {
                this.usuarios = usuarios;
                this.usuarios.forEach(usr => {
                    this.usuariosSelectItem.push({ label: usr.nomeUsuario, value: usr.idUsuario });
                });
            });
        } else {
            this._usuarioService.buscarUsuariosFuncionalidadeHttp(idCliente, 'Dashboards - Usu\u00e1rios', usuario.idUsuario)
                .subscribe(usuarios => {
                    this.usuarios = usuarios;
                    this.usuarios.forEach(usr => {
                        this.usuariosSelectItem.push({ label: usr.nomeUsuario, value: usr.idUsuario });
                    });

                });
        }
        if (this.origem === 'ALTERAR') {
            this.parametroGrafico = this.parametroGraficoInput;

            if (this.parametroGrafico.dataInicioReferencia !== null && this.parametroGrafico.dataInicioReferencia !== undefined) {
                this.parametroGrafico.dataInicioReferencia = new Date(this.parametroGraficoInput.dataInicioReferencia);
                this.ultimosDias = false;
                this.ultimasSemanas = false;
                this.ultimosMeses = false;
                this.ultimosAnos = false;
                this.rangeDatas = true;
                this.periodicidades = new Array<PeriodicidadeDados>();
            }
            if (this.parametroGrafico.dataFimReferencia !== null && this.parametroGrafico.dataFimReferencia !== undefined) {
                this.parametroGrafico.dataFimReferencia = new Date(this.parametroGraficoInput.dataFimReferencia);
                this.ultimosDias = false;
                this.ultimasSemanas = false;
                this.ultimosMeses = false;
                this.ultimosAnos = false;
                this.rangeDatas = true;
                this.periodicidades = new Array<PeriodicidadeDados>();
            }
            if (this.parametroGrafico.diasAte !== null && this.parametroGrafico.diasAte !== undefined) {
                this.ultimosDias = true;
                this.ultimasSemanas = false;
                this.ultimosMeses = false;
                this.ultimosAnos = false;
                this.rangeDatas = false;
                this.periodicidades = new Array<PeriodicidadeDados>();
            }
            if (this.parametroGrafico.semanasAte !== null && this.parametroGrafico.semanasAte !== undefined) {
                this.ultimosDias = false;
                this.ultimasSemanas = true;
                this.ultimosMeses = false;
                this.ultimosAnos = false;
                this.rangeDatas = false;
                this.periodicidades = new Array<PeriodicidadeDados>();
                const periodicidadeDiaria = new PeriodicidadeDados();
                periodicidadeDiaria.idPeriodicidadeDados = 1;
                periodicidadeDiaria.descricaoPeriodicidadeDados = 'Diario';
                const periodicidadeSemanal = new PeriodicidadeDados();
                periodicidadeSemanal.idPeriodicidadeDados = 2;
                periodicidadeSemanal.descricaoPeriodicidadeDados = 'Semanal';
                this.periodicidades.push(periodicidadeDiaria);
                this.periodicidades.push(periodicidadeSemanal);
            }
            if (this.parametroGrafico.mesesAte !== null && this.parametroGrafico.mesesAte !== undefined) {
                this.ultimosDias = false;
                this.ultimasSemanas = false;
                this.ultimosMeses = true;
                this.ultimosAnos = false;
                this.rangeDatas = false;
                this.periodicidades = new Array<PeriodicidadeDados>();
                const periodicidadeSemanal = new PeriodicidadeDados();
                periodicidadeSemanal.idPeriodicidadeDados = 2;
                periodicidadeSemanal.descricaoPeriodicidadeDados = 'Semanal';
                const periodicidadeMensal = new PeriodicidadeDados();
                periodicidadeMensal.idPeriodicidadeDados = 3;
                periodicidadeMensal.descricaoPeriodicidadeDados = 'Mensal';
                this.periodicidades.push(periodicidadeSemanal);
                this.periodicidades.push(periodicidadeMensal);
            }
            if (this.parametroGrafico.anosAte !== null && this.parametroGrafico.anosAte !== undefined) {
                this.ultimosDias = false;
                this.ultimasSemanas = false;
                this.ultimosMeses = false;
                this.ultimosAnos = true;
                this.rangeDatas = false;
                this.periodicidades = new Array<PeriodicidadeDados>();
                const periodicidadeMensal = new PeriodicidadeDados();
                periodicidadeMensal.idPeriodicidadeDados = 3;
                periodicidadeMensal.descricaoPeriodicidadeDados = 'Mensal';
                const periodicidadeAnual = new PeriodicidadeDados();
                periodicidadeAnual.idPeriodicidadeDados = 4;
                periodicidadeAnual.descricaoPeriodicidadeDados = 'Anual';
                this.periodicidades.push(periodicidadeMensal);
                this.periodicidades.push(periodicidadeAnual);
            }

            forkJoin(this._indicadorService.obterIndicadoresClienteHttp(idCliente),
                this._clienteService.obterAreasUsuarioHttp(usuario.idUsuario))
                .subscribe(([indicadores, areas]) => {
                    this.areas = areas;
                    this.areas.forEach(areaCliente => {
                        this.areasSelectItem.push({ label: areaCliente.area.nomeArea, value: areaCliente.idAreaCliente });
                    });
                    this.indicadores = indicadores;

                    forkJoin(this._dashboardService.obterPontosFisicosParametroGraficoHttp(this.parametroGrafico.idParametroGrafico),
                        this._dashboardService.obterTiposPontoFisicoParametroGraficoHttp(this.parametroGrafico.idParametroGrafico),
                        this._dashboardService.obterRegioesParametroGraficoHttp(this.parametroGrafico.idParametroGrafico),
                        this._dashboardService.obterUsuariosParametroGraficoHttp(this.parametroGrafico.idParametroGrafico),
                        this._dashboardService.obterAreasParametroGraficoHttp(this.parametroGrafico.idParametroGrafico)).
                        subscribe(([pontosFisicosParametrosGrafico, tipos, regioesParametroGrafico,
                            usuariosParametroGrafico, areasParametroGrafico]) => {
                            this.pontosFisicosParametroGrafico = pontosFisicosParametrosGrafico;
                            this.tiposPontoFisicoParametroGrafico = tipos;
                            this.regioesParametroGrafico = regioesParametroGrafico;
                            this.areasParametroGrafico = areasParametroGrafico;
                            this.usuariosParametroGrafico = usuariosParametroGrafico;

                            const idsAreas = new Array();
                            for (const area of this.areas) {
                                for (const areaParametroGrafico of this.areasParametroGrafico) {
                                    if (area.idAreaCliente === areaParametroGrafico.idAreaCliente) {
                                        idsAreas.push(area.idAreaCliente);
                                        this.areasSelecionadas.push(area.idAreaCliente);
                                        break;
                                    }
                                }
                            }
                            forkJoin(this._regiaoService.obterRegioesAreaHttp(idsAreas),
                                this._pontoFisicoService.obterTiposPontosFisicoAreaHttp(idsAreas),
                                this._pontoFisicoService.obterPontosFisicosAreaHttp(idsAreas))
                                .subscribe(([rg, tpf, pfs]) => {
                                    this.pontosFisicos = pfs;
                                    this.pontosFisicos.forEach(pontoFisico => {
                                        this.pontosFisicosSelectItem.push({
                                            label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico
                                        });
                                    });
                                    this.regioes = rg;
                                    this.regioes.forEach(regiao => {
                                        this.regioesSelectItem.push({
                                            label: regiao.regiao.descricaoRegiao, value: regiao.idRegiaoCliente
                                        });
                                    });
                                    this.tiposPontoFisico = tpf;
                                    this.tiposPontoFisico.forEach(tipoPontoFisico => {
                                        this.tipoPontoFisicoSelectItem.push({
                                            label: tipoPontoFisico.descricaoTipoPontoFisico, value: tipoPontoFisico.idTipoPontoFisico
                                        });
                                    });
                                });

                            for (const regiao of this.regioes) {
                                for (const regiaoParametroGrafico of this.regioesParametroGrafico) {
                                    if (regiao.idRegiaoCliente === regiaoParametroGrafico.idRegiaoCliente) {
                                        this.regioesSelecionadas.push(regiao.idRegiaoCliente);
                                        break;
                                    }
                                }
                            }

                            for (const usr of this.usuarios) {
                                for (const usuarioParametroGrafico of this.usuariosParametroGrafico) {
                                    if (usr.idUsuario === usuarioParametroGrafico.idUsuario) {
                                        this.usuariosSelecionados.push(usr.idUsuario);
                                        break;
                                    }
                                }
                            }

                            for (const pt of this.pontosFisicos) {
                                for (const pontoFisicoParametroGrafico of this.pontosFisicosParametroGrafico) {
                                    if (pt.idPontoFisico === pontoFisicoParametroGrafico.idPontoFisico) {
                                        this.pontosFisicosSelecionados.push(pt.idPontoFisico);
                                        break;
                                    }
                                }
                            }

                            for (const tipoPontoFisico of this.tiposPontoFisico) {
                                for (const tipoPontoFisicoParametroGrafico of this.tiposPontoFisicoParametroGrafico) {
                                    if (tipoPontoFisico.idTipoPontoFisico === tipoPontoFisicoParametroGrafico.idTipoPontoFisico) {
                                        this.tiposPontoFisicoSelecionados.push(tipoPontoFisico.idTipoPontoFisico);
                                        break;
                                    }
                                }
                            }
                        });
                    this.loading = false;
                });
        } else {
            forkJoin(this._indicadorService.obterIndicadoresClienteHttp(idCliente),
                this._clienteService.obterAreasUsuarioHttp(usuario.idUsuario))
                .subscribe(([indicadores, areas]) => {
                    this.areas = areas;
                    this.areas.forEach(areaCliente => {
                        this.areasSelectItem.push({ label: areaCliente.area.nomeArea, value: areaCliente.idAreaCliente });
                    });
                    this.indicadores = indicadores;
                    this.loading = false;
                });
        }
    }

    salvar(): void {
        if (this.origem === 'ALTERAR') {
            this.manterPontosFisicosParametroGrafico();
            this.manterTiposPontoFisicoParametroGrafico();
            this.manterRegioesParametroGrafico();
            this.manterAreasParametroGrafico();
            this.manterUsuariosParametroGrafico();
        } else {
            this.inserirPontosFisicosParametroGrafico();
            this.inserirTiposPontoFisicoParametroGrafico();
            this.inserirRegioesParametroGrafico();
            this.inserirAreasParametroGrafico();
            this.inserirUsuariosParametroGrafico();
        }
        if (!this.rangeDatas) {
            this.parametroGrafico.dataInicioReferencia = null;
            this.parametroGrafico.dataFimReferencia = null;
        }
        if (!this.ultimosDias) {
            this.parametroGrafico.diasAte = null;
        }
        if (!this.ultimasSemanas) {
            this.parametroGrafico.semanasAte = null;
        }
        if (!this.ultimosMeses) {
            this.parametroGrafico.mesesAte = null;
        }
        if (!this.ultimosAnos) {
            this.parametroGrafico.anosAte = null;
        }
        this.parametrosGraficoEvent.emit(this.parametroGrafico);
    }

    preencherIndicadorParametroGrafico(idIndicador: number) {
        this._indicadorService.obterIndicadorPorIdHttp(idIndicador).subscribe(indicador => {
            this.parametroGrafico.indicador = indicador;
        });
    }

    selecionarUltimosDias() {
        this.ultimosDias = true;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.ultimosAnos = false;
        this.rangeDatas = false;
        this.periodicidades = new Array<PeriodicidadeDados>();
    }

    selecionarUltimasSemanas() {
        this.ultimosDias = false;
        this.ultimasSemanas = true;
        this.ultimosMeses = false;
        this.ultimosAnos = false;
        this.rangeDatas = false;
        this.periodicidades = new Array<PeriodicidadeDados>();
        const periodicidadeDiaria = new PeriodicidadeDados();
        periodicidadeDiaria.idPeriodicidadeDados = 1;
        periodicidadeDiaria.descricaoPeriodicidadeDados = 'Diario';
        const periodicidadeSemanal = new PeriodicidadeDados();
        periodicidadeSemanal.idPeriodicidadeDados = 2;
        periodicidadeSemanal.descricaoPeriodicidadeDados = 'Semanal';
        this.periodicidades.push(periodicidadeDiaria);
        this.periodicidades.push(periodicidadeSemanal);
    }

    selecionarUltimosMeses() {
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = true;
        this.ultimosAnos = false;
        this.rangeDatas = false;
        this.periodicidades = new Array<PeriodicidadeDados>();
        const periodicidadeSemanal = new PeriodicidadeDados();
        periodicidadeSemanal.idPeriodicidadeDados = 2;
        periodicidadeSemanal.descricaoPeriodicidadeDados = 'Semanal';
        const periodicidadeMensal = new PeriodicidadeDados();
        periodicidadeMensal.idPeriodicidadeDados = 3;
        periodicidadeMensal.descricaoPeriodicidadeDados = 'Mensal';
        this.periodicidades.push(periodicidadeSemanal);
        this.periodicidades.push(periodicidadeMensal);
    }

    selecionarUltimosAnos() {
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.ultimosAnos = true;
        this.rangeDatas = false;
        this.periodicidades = new Array<PeriodicidadeDados>();
        const periodicidadeMensal = new PeriodicidadeDados();
        periodicidadeMensal.idPeriodicidadeDados = 3;
        periodicidadeMensal.descricaoPeriodicidadeDados = 'Mensal';
        const periodicidadeAnual = new PeriodicidadeDados();
        periodicidadeAnual.idPeriodicidadeDados = 4;
        periodicidadeAnual.descricaoPeriodicidadeDados = 'Anual';
        this.periodicidades.push(periodicidadeMensal);
        this.periodicidades.push(periodicidadeAnual);
    }

    selecionarRangeDatas() {
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.ultimosAnos = false;
        this.rangeDatas = true;
        this.periodicidades = new Array<PeriodicidadeDados>();
    }

    selecionaIndicadores(tipoIndicador: number) {
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
        if (tipoIndicador.toString() === '2') {
            this._indicadorService.obterIndicadoresClienteHttp(idCliente).subscribe(indicadores => {
                this.indicadores = indicadores;
            });
        } else {
            this.indicadores = new Array<Indicador>();
        }
    }

    selecionarPontosFisicosArea(idsArea: number[]) {
        this.pontosFisicos = new Array<PontoFisico>();
        this.pontosFisicosSelectItem = new Array<SelectItem>();
        this.tiposPontoFisico = new Array<TipoPontoFisico>();
        this.tipoPontoFisicoSelectItem = new Array<SelectItem>();
        this.regioes = new Array<RegiaoCliente>();
        this.regioesSelectItem = new Array<SelectItem>();
        this._dashboardService.removerPontosFisicosParametroGraficoHttp(this.parametroGrafico.pontosFisicosParametroGrafico)
            .subscribe(response => {
                this.statusCode = response.status;
                this.parametroGrafico.pontosFisicosParametroGrafico = new Array<PontoFisicoParametroGrafico>();
                this.pontosFisicosSelecionados = new Array<number>();
            }, errorCode => {
                this.statusCode = errorCode;
            });

        this._dashboardService.removerTiposPontoFisicoParametroGraficoHttp(this.parametroGrafico.tiposPontoFisicoParametroGrafico)
            .subscribe(response => {
                this.statusCode = response.status;
                this.parametroGrafico.tiposPontoFisicoParametroGrafico = new Array<TipoPontoFisicoParametroGrafico>();
                this.tiposPontoFisicoSelecionados = new Array<number>();
            }, errorCode => {
                this.statusCode = errorCode;
            });

        this._dashboardService.removerRegioesParametroGraficoHttp(this.parametroGrafico.regioesParametroGrafico)
            .subscribe(response => {
                this.statusCode = response.status;
                this.parametroGrafico.regioesParametroGrafico = new Array<RegiaoParametroGrafico>();
                this.regioesSelecionadas = new Array<number>();
            }, errorCode => {
                this.statusCode = errorCode;
            });

        if (idsArea.length > 0) {
            forkJoin(this._pontoFisicoService.obterPontosFisicosAreaHttp(idsArea),
                this._regiaoService.obterRegioesAreaHttp(idsArea),
                this._pontoFisicoService.obterTiposPontosFisicoAreaHttp(idsArea))
                .subscribe(([pfs, rgs, tpf]) => {
                    this.pontosFisicos = pfs;
                    this.pontosFisicos.forEach(pontoFisico => {
                        this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                    });
                    this.regioes = rgs;
                    this.regioes.forEach(regiao => {
                        this.regioesSelectItem.push({ label: regiao.regiao.descricaoRegiao, value: regiao.idRegiaoCliente });
                    });
                    this.tiposPontoFisico = tpf;
                    this.tiposPontoFisico.forEach(tipoPontoFisico => {
                        this.tipoPontoFisicoSelectItem.push({
                            label: tipoPontoFisico.descricaoTipoPontoFisico, value: tipoPontoFisico.idTipoPontoFisico
                        });
                    });
                    this.loading = false;
                });
        } else {
            this.loading = false;
        }

    }

    selecionarPontosFisicosRegiao(idsRegioes: number[]) {
        this.pontosFisicos = new Array<PontoFisico>();
        this.pontosFisicosSelectItem = new Array<SelectItem>();
        this.tiposPontoFisico = new Array<TipoPontoFisico>();
        this.tipoPontoFisicoSelectItem = new Array<SelectItem>();
        this._dashboardService.removerPontosFisicosParametroGraficoHttp(this.parametroGrafico.pontosFisicosParametroGrafico)
            .subscribe(response => {
                this.statusCode = response.status;
                this.parametroGrafico.pontosFisicosParametroGrafico = new Array<PontoFisicoParametroGrafico>();
                this.pontosFisicosSelecionados = new Array<number>();
            }, errorCode => {
                this.statusCode = errorCode;
            });

        this._dashboardService.removerTiposPontoFisicoParametroGraficoHttp(this.parametroGrafico.tiposPontoFisicoParametroGrafico)
            .subscribe(response => {
                this.statusCode = response.status;
                this.parametroGrafico.tiposPontoFisicoParametroGrafico = new Array<TipoPontoFisicoParametroGrafico>();
                this.tiposPontoFisicoSelecionados = new Array<number>();
            }, errorCode => {
                this.statusCode = errorCode;
            });

        if (idsRegioes.length > 0) {
            forkJoin(this._pontoFisicoService.obterPontosFisicosRegiaoHttp(idsRegioes),
                this._pontoFisicoService.obterTiposPontosFisicoRegiaoHttp(idsRegioes)).
                subscribe(([pontosFisicos, tiposPontoFisico]) => {
                    pontosFisicos.forEach(pf => {
                        if (this.areasSelecionadas.find(area => area === pf.areaCliente.idAreaCliente)) {
                            this.pontosFisicos.push(pf);
                        }
                    });
                    this.pontosFisicos.forEach(pontoFisico => {
                        this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                    });

                    tiposPontoFisico.forEach(tpf => {
                        if (this.pontosFisicos.find(pf => pf.tipoPontoFisico.idTipoPontoFisico === tpf.idTipoPontoFisico)) {
                            this.tiposPontoFisico.push(tpf);
                        }
                    });
                    this.tiposPontoFisico.forEach(tipoPontoFisico => {
                        this.tipoPontoFisicoSelectItem.push({
                            label: tipoPontoFisico.descricaoTipoPontoFisico, value: tipoPontoFisico.idTipoPontoFisico
                        });
                    });
                });
        } else {
            if (this.areasSelecionadas.length > 0) {
                forkJoin(this._pontoFisicoService.obterPontosFisicosAreaHttp(this.areasSelecionadas),
                    this._pontoFisicoService.obterTiposPontosFisicoAreaHttp(this.areasSelecionadas)).
                    subscribe(([pontosFisicos, tiposPontoFisico]) => {
                        this.pontosFisicos = pontosFisicos;
                        this.pontosFisicos.forEach(pontoFisico => {
                            this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                        });

                        this.tiposPontoFisico = tiposPontoFisico;
                        this.tiposPontoFisico.forEach(tipoPontoFisico => {
                            this.tipoPontoFisicoSelectItem.push({
                                label: tipoPontoFisico.descricaoTipoPontoFisico, value: tipoPontoFisico.idTipoPontoFisico
                            });
                        });
                    });
            }
        }
    }

    selecionarPontosFisicosTipoPF(idsTipoPontoFisico: number[]) {
        this.pontosFisicos = new Array<PontoFisico>();
        this.pontosFisicosSelectItem = new Array<SelectItem>();
        this._dashboardService.removerPontosFisicosParametroGraficoHttp(this.parametroGrafico.pontosFisicosParametroGrafico)
            .subscribe(response => {
                this.statusCode = response.status;
                this.parametroGrafico.pontosFisicosParametroGrafico = new Array<PontoFisicoParametroGrafico>();
                this.pontosFisicosSelecionados = new Array<number>();
            }, errorCode => {
                this.statusCode = errorCode;
            });

        if (idsTipoPontoFisico.length > 0) {
            if (this.regioesSelecionadas.length === 0) {
                this.regioes = new Array<RegiaoCliente>();
                this.regioesSelectItem = new Array<SelectItem>();
                forkJoin(this._regiaoService.obterRegioesTipoPontoFisicoHttp(idsTipoPontoFisico, this.areasSelecionadas),
                    this._pontoFisicoService.obterPontosFisicosTipoPontoFisicoHttp(idsTipoPontoFisico))
                    .subscribe(([regioes, pontosFisicos]) => {
                        this.regioes = regioes;
                        this.regioes.forEach(regiao => {
                            this.regioesSelectItem.push({ label: regiao.regiao.descricaoRegiao, value: regiao.idRegiaoCliente });
                        });

                        pontosFisicos.forEach(pf => {
                            if (this.areasSelecionadas.find(area => area === pf.areaCliente.idAreaCliente)) {
                                this.pontosFisicos.push(pf);
                            }
                        });
                        this.pontosFisicos.forEach(pontoFisico => {
                            this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                        });
                    });
            } else {
                this._pontoFisicoService.obterPontosFisicosTipoPontoFisicoRegiaoHttp(idsTipoPontoFisico, this.regioesSelecionadas).
                    subscribe(pontosFisicos => {
                        pontosFisicos.forEach(pf => {
                            if (this.areasSelecionadas.find(area => area === pf.areaCliente.idAreaCliente)) {
                                this.pontosFisicos.push(pf);
                            }
                        });
                        this.pontosFisicos.forEach(pontoFisico => {
                            this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                        });
                    });
            }
        } else {
            if (this.regioesSelecionadas.length === 0) {
                this._pontoFisicoService.obterPontosFisicoClienteHttp(parseInt(this._cookieService.get('idCliente'), 10)).
                    subscribe(pontosFisicos => {
                        pontosFisicos.forEach(pf => {
                            if (this.areasSelecionadas.find(area => area === pf.areaCliente.idAreaCliente)) {
                                this.pontosFisicos.push(pf);
                            }
                        });
                        this.pontosFisicos.forEach(pontoFisico => {
                            this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                        });
                    });
            } else {
                this._pontoFisicoService.obterPontosFisicosRegiaoHttp(this.regioesSelecionadas).subscribe(pontosFisicos => {
                    pontosFisicos.forEach(pf => {
                        if (this.areasSelecionadas.find(area => area === pf.areaCliente.idAreaCliente)) {
                            this.pontosFisicos.push(pf);
                        }
                    });
                    this.pontosFisicos.forEach(pontoFisico => {
                        this.pontosFisicosSelectItem.push({ label: pontoFisico.nomePontoFisico, value: pontoFisico.idPontoFisico });
                    });
                });
            }

        }
    }

    manterPontosFisicosParametroGrafico(): void {
        const pontosFisicosParametroGraficoInsert = new Array<PontoFisicoParametroGrafico>();
        const pontosFisicosParametroGraficoRemove = new Array<PontoFisicoParametroGrafico>();
        const setIdsPontosFisicos = new Set<number>();
        this.pontosFisicosSelecionados.forEach(idPontoFisico => {
            setIdsPontosFisicos.add(idPontoFisico);
        });

        const setPontosFisicosParametroGrafico = new Set<number>();
        this.pontosFisicosParametroGrafico.forEach(pontoFisicoParametroGrafico => {
            setPontosFisicosParametroGrafico.add(pontoFisicoParametroGrafico.idPontoFisico);
        });

        this.pontosFisicos.forEach(pontoFisico => {
            if (setIdsPontosFisicos.has(pontoFisico.idPontoFisico)) {
                if (!setPontosFisicosParametroGrafico.has(pontoFisico.idPontoFisico)) {
                    const pontoFPG = new PontoFisicoParametroGrafico();
                    pontoFPG.idPontoFisico = pontoFisico.idPontoFisico;
                    pontoFPG.idParametroGrafico = this.parametroGrafico.idParametroGrafico;
                    pontosFisicosParametroGraficoInsert.push(pontoFPG);
                    this.parametroGrafico.pontosFisicosParametroGrafico.push(pontoFPG);
                }
            } else if (setPontosFisicosParametroGrafico.size > 0) {
                this.pontosFisicosParametroGrafico.forEach(pontoFisicoParametroGrafico => {
                    if (pontoFisicoParametroGrafico.idPontoFisico === pontoFisico.idPontoFisico) {
                        pontosFisicosParametroGraficoRemove.push(pontoFisicoParametroGrafico);
                        this.parametroGrafico.pontosFisicosParametroGrafico = this.parametroGrafico.pontosFisicosParametroGrafico.filter(
                            item => item.idPontoFisico !== pontoFisicoParametroGrafico.idPontoFisico);
                    }
                });
            }
        });

        if (pontosFisicosParametroGraficoInsert.length > 0) {
            this._dashboardService.cadastrarPontosFisicosParametroGraficoHttp(pontosFisicosParametroGraficoInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (pontosFisicosParametroGraficoRemove.length > 0) {
            this._dashboardService.removerPontosFisicosParametroGraficoHttp(pontosFisicosParametroGraficoRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
    }

    manterTiposPontoFisicoParametroGrafico(): void {
        const tiposPontoFisicoParametroGraficoInsert = new Array<TipoPontoFisicoParametroGrafico>();
        const tiposPontoFisicoParametroGraficoRemove = new Array<TipoPontoFisicoParametroGrafico>();
        const setIdsTiposPontoFisico = new Set<number>();
        this.tiposPontoFisicoSelecionados.forEach(idPontoFisico => {
            setIdsTiposPontoFisico.add(idPontoFisico);
        });

        const setTiposPontoFisicoParametroGrafico = new Set<number>();
        this.tiposPontoFisicoParametroGrafico.forEach(tipoPontoFisicoParametroGrafico => {
            setTiposPontoFisicoParametroGrafico.add(tipoPontoFisicoParametroGrafico.idTipoPontoFisico);
        });

        this.tiposPontoFisico.forEach(tipoPontoFisico => {
            if (setIdsTiposPontoFisico.has(tipoPontoFisico.idTipoPontoFisico)) {
                if (!setTiposPontoFisicoParametroGrafico.has(tipoPontoFisico.idTipoPontoFisico)) {
                    const pontoFPG = new TipoPontoFisicoParametroGrafico();
                    pontoFPG.idTipoPontoFisico = tipoPontoFisico.idTipoPontoFisico;
                    pontoFPG.idParametroGrafico = this.parametroGrafico.idParametroGrafico;
                    tiposPontoFisicoParametroGraficoInsert.push(pontoFPG);
                    this.parametroGrafico.tiposPontoFisicoParametroGrafico.push(pontoFPG);
                }
            } else if (setTiposPontoFisicoParametroGrafico.size > 0) {
                this.tiposPontoFisicoParametroGrafico.forEach(tipoPontoFisicoParametroGrafico => {
                    if (tipoPontoFisicoParametroGrafico.idTipoPontoFisico === tipoPontoFisico.idTipoPontoFisico) {
                        tiposPontoFisicoParametroGraficoRemove.push(tipoPontoFisicoParametroGrafico);
                        this.parametroGrafico.tiposPontoFisicoParametroGrafico = this.parametroGrafico.tiposPontoFisicoParametroGrafico
                            .filter(item => item.idTipoPontoFisico !== tipoPontoFisicoParametroGrafico.idTipoPontoFisico);
                    }
                });
            }
        });

        if (tiposPontoFisicoParametroGraficoInsert.length > 0) {
            this._dashboardService.cadastrarTiposPontoFisicoParametroGraficoHttp(tiposPontoFisicoParametroGraficoInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (tiposPontoFisicoParametroGraficoRemove.length > 0) {
            this._dashboardService.removerTiposPontoFisicoParametroGraficoHttp(tiposPontoFisicoParametroGraficoRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
    }

    manterRegioesParametroGrafico(): void {
        const regioesParametroGraficoInsert = new Array<RegiaoParametroGrafico>();
        const regioesParametroGraficoRemove = new Array<RegiaoParametroGrafico>();
        const setIdsRegioes = new Set<number>();
        this.regioesSelecionadas.forEach(idRegiaoCliente => {
            setIdsRegioes.add(idRegiaoCliente);
        });

        const setRegioesParametroGrafico = new Set<number>();
        this.regioesParametroGrafico.forEach(regiaoParametroGrafico => {
            setRegioesParametroGrafico.add(regiaoParametroGrafico.idRegiaoCliente);
        });

        this.regioes.forEach(regiao => {
            if (setIdsRegioes.has(regiao.idRegiaoCliente)) {
                if (!setRegioesParametroGrafico.has(regiao.idRegiaoCliente)) {
                    const regiaoPG = new RegiaoParametroGrafico();
                    regiaoPG.idRegiaoCliente = regiao.idRegiaoCliente;
                    regiaoPG.idParametroGrafico = this.parametroGrafico.idParametroGrafico;
                    regioesParametroGraficoInsert.push(regiaoPG);
                    this.parametroGrafico.regioesParametroGrafico.push(regiaoPG);
                }
            } else if (setRegioesParametroGrafico.size > 0) {
                this.regioesParametroGrafico.forEach(regiaoParametroGrafico => {
                    if (regiaoParametroGrafico.idRegiaoCliente === regiao.idRegiaoCliente) {
                        regioesParametroGraficoRemove.push(regiaoParametroGrafico);
                        this.parametroGrafico.regioesParametroGrafico = this.parametroGrafico.regioesParametroGrafico.filter(
                            item => item.idRegiaoCliente !== regiaoParametroGrafico.idRegiaoCliente);
                    }
                });
            }
        });

        if (regioesParametroGraficoInsert.length > 0) {
            this._dashboardService.cadastrarRegioesParametroGraficoHttp(regioesParametroGraficoInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (regioesParametroGraficoRemove.length > 0) {
            this._dashboardService.removerRegioesParametroGraficoHttp(regioesParametroGraficoRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
    }

    manterAreasParametroGrafico(): void {
        const areasParametroGraficoInsert = new Array<AreaParametroGrafico>();
        const areasParametroGraficoRemove = new Array<AreaParametroGrafico>();
        const setIdsAreas = new Set<number>();
        this.areasSelecionadas.forEach(idAreaCliente => {
            setIdsAreas.add(idAreaCliente);
        });

        const setAreasParametroGrafico = new Set<number>();
        this.areasParametroGrafico.forEach(areaParametroGrafico => {
            setAreasParametroGrafico.add(areaParametroGrafico.idAreaCliente);
        });

        this.areas.forEach(area => {
            if (setIdsAreas.has(area.idAreaCliente)) {
                if (!setAreasParametroGrafico.has(area.idAreaCliente)) {
                    const areaPG = new AreaParametroGrafico();
                    areaPG.idAreaCliente = area.idAreaCliente;
                    areaPG.idParametroGrafico = this.parametroGrafico.idParametroGrafico;
                    areasParametroGraficoInsert.push(areaPG);
                    this.parametroGrafico.areasParametroGrafico.push(areaPG);
                }
            } else if (setAreasParametroGrafico.size > 0) {
                this.areasParametroGrafico.forEach(areaParametroGrafico => {
                    if (areaParametroGrafico.idAreaCliente === area.idAreaCliente) {
                        areasParametroGraficoRemove.push(areaParametroGrafico);
                        this.parametroGrafico.areasParametroGrafico = this.parametroGrafico.areasParametroGrafico.filter(
                            item => item.idAreaCliente !== areaParametroGrafico.idAreaCliente);
                    }
                });
            }
        });

        if (areasParametroGraficoInsert.length > 0) {
            this._dashboardService.cadastrarAreasParametroGraficoHttp(areasParametroGraficoInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (areasParametroGraficoRemove.length > 0) {
            this._dashboardService.removerAreasParametroGraficoHttp(areasParametroGraficoRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
    }

    manterUsuariosParametroGrafico(): void {
        const usuariosParametroGraficoInsert = new Array<UsuarioParametroGrafico>();
        const usuariosParametroGraficoRemove = new Array<UsuarioParametroGrafico>();
        const setIdsUsuarios = new Set<number>();
        this.usuariosSelecionados.forEach(idUsuario => {
            setIdsUsuarios.add(idUsuario);
        });

        const setUsuariosParametroGrafico = new Set<number>();
        this.usuariosParametroGrafico.forEach(usuarioParametroGrafico => {
            setUsuariosParametroGrafico.add(usuarioParametroGrafico.idUsuario);
        });

        this.usuarios.forEach(usuario => {
            if (setIdsUsuarios.has(usuario.idUsuario)) {
                if (!setUsuariosParametroGrafico.has(usuario.idUsuario)) {
                    const usuarioPG = new UsuarioParametroGrafico();
                    usuarioPG.idUsuario = usuario.idUsuario;
                    usuarioPG.idParametroGrafico = this.parametroGrafico.idParametroGrafico;
                    usuariosParametroGraficoInsert.push(usuarioPG);
                    this.parametroGrafico.usuariosParametroGrafico.push(usuarioPG);
                }
            } else if (setUsuariosParametroGrafico.size > 0) {
                this.usuariosParametroGrafico.forEach(usuarioParametroGrafico => {
                    if (usuarioParametroGrafico.idUsuario === usuario.idUsuario) {
                        usuariosParametroGraficoRemove.push(usuarioParametroGrafico);
                        this.parametroGrafico.usuariosParametroGrafico = this.parametroGrafico.usuariosParametroGrafico.filter(
                            item => item.idUsuario !== usuarioParametroGrafico.idUsuario);
                    }
                });
            }
        });

        if (usuariosParametroGraficoInsert.length > 0) {
            this._dashboardService.cadastrarUsuariosParametroGraficoHttp(usuariosParametroGraficoInsert)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }

        if (usuariosParametroGraficoRemove.length > 0) {
            this._dashboardService.removerUsuariosParametroGraficoHttp(usuariosParametroGraficoRemove)
                .subscribe(response => {
                    this.statusCode = response.status;
                }, errorCode => {
                    this.statusCode = errorCode;
                });
        }
    }

    inserirPontosFisicosParametroGrafico(): void {
        const pontoFisicoParametroGraficoInsert = new Array<PontoFisicoParametroGrafico>();
        this.pontosFisicos.forEach(pf => {
            if (this.pontosFisicosSelecionados.find(pontoFisico => pontoFisico === pf.idPontoFisico)) {
                const pontoFisicoParametroGrafico = new PontoFisicoParametroGrafico();
                pontoFisicoParametroGrafico.idPontoFisico = pf.idPontoFisico;
                pontoFisicoParametroGraficoInsert.push(pontoFisicoParametroGrafico);
            }
        });
        if (pontoFisicoParametroGraficoInsert.length > 0) {
            this.parametroGrafico.pontosFisicosParametroGrafico = pontoFisicoParametroGraficoInsert;
        }
    }

    inserirTiposPontoFisicoParametroGrafico(): void {
        const tiposPontoFisicoParametroGraficoInsert = new Array<TipoPontoFisicoParametroGrafico>();
        this.tiposPontoFisico.forEach(tpf => {
            if (this.tiposPontoFisicoSelecionados.find(tipo => tipo === tpf.idTipoPontoFisico)) {
                const tipoPontoFisicoParametroGrafico = new TipoPontoFisicoParametroGrafico();
                tipoPontoFisicoParametroGrafico.idTipoPontoFisico = tpf.idTipoPontoFisico;
                tiposPontoFisicoParametroGraficoInsert.push(tipoPontoFisicoParametroGrafico);
            }
        });
        if (tiposPontoFisicoParametroGraficoInsert.length > 0) {
            this.parametroGrafico.tiposPontoFisicoParametroGrafico = tiposPontoFisicoParametroGraficoInsert;
        }

    }

    inserirRegioesParametroGrafico(): void {
        const regioesParametroGraficoInsert = new Array<RegiaoParametroGrafico>();
        this.regioes.forEach(r => {
            if (this.regioesSelecionadas.find(regiao => regiao === r.idRegiaoCliente)) {
                const regiaoParametroGrafico = new RegiaoParametroGrafico();
                regiaoParametroGrafico.idRegiaoCliente = r.idRegiaoCliente;
                regioesParametroGraficoInsert.push(regiaoParametroGrafico);
            }
        });
        if (regioesParametroGraficoInsert.length > 0) {
            this.parametroGrafico.regioesParametroGrafico = regioesParametroGraficoInsert;
        }

    }

    inserirAreasParametroGrafico(): void {
        const areasParametroGraficoInsert = new Array<AreaParametroGrafico>();
        this.areas.forEach(r => {
            if (this.areasSelecionadas.find(area => area === r.idAreaCliente)) {
                const areaParametroGrafico = new AreaParametroGrafico();
                areaParametroGrafico.idAreaCliente = r.idAreaCliente;
                areasParametroGraficoInsert.push(areaParametroGrafico);
            }
        });
        if (areasParametroGraficoInsert.length > 0) {
            this.parametroGrafico.areasParametroGrafico = areasParametroGraficoInsert;
        }

    }

    inserirUsuariosParametroGrafico(): void {
        const usuariosParametroGraficoInsert = new Array<UsuarioParametroGrafico>();
        this.usuarios.forEach(u => {
            if (this.usuariosSelecionados.find(usuario => usuario === u.idUsuario)) {
                const usuarioParametroGrafico = new UsuarioParametroGrafico();
                usuarioParametroGrafico.idUsuario = u.idUsuario;
                usuariosParametroGraficoInsert.push(usuarioParametroGrafico);
            }
        });
        if (usuariosParametroGraficoInsert.length > 0) {
            this.parametroGrafico.usuariosParametroGrafico = usuariosParametroGraficoInsert;
        }

    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/parametros-grafico/parametros-grafico.component.ts